import React from 'react';
import CualappLogo from './CualappLogo';

const Shell = ({ title, children, testid }) => (
  <div className="min-h-screen bg-gradient-to-br from-purple-50 to-blue-50" data-testid={testid}>
    <header className="bg-white border-b border-gray-200">
      <div className="max-w-3xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="/" className="flex items-center gap-2">
          <CualappLogo size={32} withWordmark={true} />
        </a>
        <span className="text-xs px-2 py-1 rounded-full bg-amber-100 text-amber-700 font-semibold">BETA</span>
      </div>
    </header>
    <main className="max-w-3xl mx-auto px-6 py-8 bg-white mt-6 rounded-xl border border-gray-200">
      <h1 className="text-2xl font-bold text-gray-900 mb-4">{title}</h1>
      <div className="prose prose-sm max-w-none text-gray-700 space-y-3">
        {children}
      </div>
      <div className="mt-8 pt-4 border-t border-gray-200 text-xs text-gray-500">
        <a href="/" className="text-purple-700 hover:underline">← Volver a CUALAPP</a>
        <span className="mx-2">·</span>
        <a href="/terms-beta" className="text-purple-700 hover:underline">Terminos Beta</a>
        <span className="mx-2">·</span>
        <a href="/privacy" className="text-purple-700 hover:underline">Privacidad</a>
        <span className="mx-2">·</span>
        <a href="mailto:soporte@cualapp.com" className="text-purple-700 hover:underline">soporte@cualapp.com</a>
      </div>
    </main>
  </div>
);

export const TermsBeta = () => (
  <Shell testid="page-terms-beta" title="Terminos de Servicio - Version Beta">
    <p><strong>Ultima actualizacion:</strong> 2026-02-19</p>
    <p className="text-xs text-gray-500">Jurisdiccion aplicable: Wyoming, EE. UU. (sede operativa de la entidad CUALAPP LLC).</p>

    <h2 className="text-lg font-semibold mt-4">1. Naturaleza de la Beta</h2>
    <p>CUALAPP se encuentra en fase beta cerrada. Las funcionalidades pueden cambiar, presentar errores
    o ser retiradas sin previo aviso. El uso es bajo tu propio riesgo y no garantizamos disponibilidad
    continua durante este periodo.</p>

    <h2 className="text-lg font-semibold mt-4">2. Naturaleza de CUALCOIN (Cc)</h2>
    <p><strong>CUALCOIN (Cc) es un token interno de plataforma</strong>, no una moneda de curso legal, no un instrumento financiero, no un valor mobiliario ("security"), no un deposito bancario y no representa promesa alguna de retorno de inversion. Su unico uso es operar dentro del ecosistema CUALAPP para transacciones entre usuarios y servicios. Su valor esta acoplado al USD efectivamente recibido por la plataforma a traves de CUALpay, bajo el modelo de circuito cerrado.</p>

    <h2 className="text-lg font-semibold mt-4">3. Ecosistema y nomenclatura</h2>
    <p>El lexema <strong>"CUAL"</strong> es la raiz semantica protegida del ecosistema CUALAPP
    (CUALCOIN, CUALpay, CUALverde, CUALencuesta, CUALshare, CUALtaxi, NAWARA, entre otros derivados).
    El uso de la plataforma no concede derechos sobre esta familia de denominaciones.</p>

    <h2 className="text-lg font-semibold mt-4">4. Restricciones geograficas y cumplimiento OFAC</h2>
    <p>CUALAPP <strong>no esta disponible</strong> para residentes ni para personas que se conecten desde paises bajo sanciones comerciales totales de la Oficina de Control de Activos Extranjeros del Tesoro de EE. UU. (OFAC), incluyendo, sin limitarse a: Cuba, Iran, Corea del Norte, Siria, Bielorrusia, Myanmar, Crimea y regiones ocupadas de Ucrania. Los usuarios estadounidenses estan sujetos al sistema de Recaudacion de Impuesto sobre Ventas (Sales Tax) calculado y retenido automaticamente por Stripe Tax.</p>

    <h2 className="text-lg font-semibold mt-4">5. Edad minima</h2>
    <p>El uso de CUALAPP esta restringido a personas mayores de <strong>16 anos</strong>. CUALAPP no recolecta datos de menores; cualquier cuenta detectada como perteneciente a menor de edad sera suspendida.</p>

    <h2 className="text-lg font-semibold mt-4">6. Revision automatizada y cumplimiento</h2>
    <p>CUALAPP opera un sistema automatizado de revision de cumplimiento (Compliance Engine), que:</p>
    <ul className="list-disc pl-6 space-y-1">
      <li>Analiza transacciones, listings de marketplace, stickers, encuestas y contenidos publicos para detectar actividad ilegal (drogas, armas, fraude, lavado, contenido sexual infantil, terrorismo).</li>
      <li>Puede bloquear preventivamente contenidos o cuentas ante senales de alta confianza, sujeto a revision por el equipo de CUALAPP.</li>
      <li>NO accede a mensajes privados 1-a-1 entre usuarios, salvo (a) denuncia por una de las partes, (b) obligacion legal (CSAM), o (c) orden judicial verificada.</li>
      <li>Realiza screening contra listas OFAC SDN, UN y UE en el momento del registro y en transacciones de alto valor.</li>
      <li>Toda accion queda registrada en un log de auditoria inmutable con cadena de hashes.</li>
    </ul>

    <h2 className="text-lg font-semibold mt-4">7. Pagos (CUALpay)</h2>
    <p>Durante la beta, los metodos de pago pueden estar en modo prueba o desactivados. Cualquier
    transaccion real esta sujeta a la activacion explicita de los procesadores y a la entidad
    legal operadora de CUALAPP (Wyoming LLC).</p>

    <h2 className="text-lg font-semibold mt-4">8. Conducta del usuario</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>No usar la plataforma para actividades ilegales, fraude, lavado o financiamiento ilicito.</li>
      <li>No suplantar identidades ni manipular datos del sistema.</li>
      <li>Las cuentas pueden ser suspendidas ante incumplimientos o sospechas razonables.</li>
    </ul>

    <h2 className="text-lg font-semibold mt-4">9. Limitacion de responsabilidad</h2>
    <p>Durante la beta no se ofrecen garantias de continuidad, custodia o reembolso automatico.
    Cualquier reclamo se atendera caso por caso a traves de <a href="mailto:soporte@cualapp.com" className="text-purple-700">soporte@cualapp.com</a>.</p>

    <h2 className="text-lg font-semibold mt-4">10. Cambios</h2>
    <p>Estos terminos pueden actualizarse durante la beta. Continuar usando CUALAPP tras una
    actualizacion implica aceptacion de los terminos vigentes.</p>
  </Shell>
);

export const Privacy = () => (
  <Shell testid="page-privacy" title="Politica de Privacidad">
    <p><strong>Ultima actualizacion:</strong> 2026-02-19</p>

    <h2 className="text-lg font-semibold mt-4">1. Datos que recolectamos</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>Datos de cuenta: nombre, correo, contrasena (hasheada), pais.</li>
      <li>Datos de uso: bitacora de acciones, dispositivos, idioma, IP.</li>
      <li>Datos KYC (cuando aplique): documentos de identidad, en almacenamiento cifrado.</li>
      <li>Datos de pago: referencias minimas para conciliacion. CUALAPP no almacena numeros de tarjeta.</li>
    </ul>

    <h2 className="text-lg font-semibold mt-4">2. Para que los usamos</h2>
    <ul className="list-disc pl-6 space-y-1">
      <li>Operar el ecosistema (autenticacion, transacciones, antifraude).</li>
      <li>Cumplimiento legal y prevencion de uso indebido.</li>
      <li>Mejora del producto y soporte al usuario.</li>
    </ul>

    <h2 className="text-lg font-semibold mt-4">3. Con quien los compartimos</h2>
    <p>Solo con proveedores estrictamente necesarios (procesadores de pago, infraestructura) bajo
    acuerdos de confidencialidad. No vendemos datos personales.</p>

    <h2 className="text-lg font-semibold mt-4">4. Tus derechos</h2>
    <p>Puedes solicitar acceso, rectificacion o eliminacion de tus datos escribiendo a
    <a href="mailto:soporte@cualapp.com" className="text-purple-700"> soporte@cualapp.com</a>.</p>

    <h2 className="text-lg font-semibold mt-4">5. Seguridad</h2>
    <p>Empleamos hashing de contrasenas, JWT rotados, rate-limiting, proteccion contra fuerza bruta
    por correo y registro de auditoria. Durante la beta puede haber huecos remanentes; reportalos al
    equipo de soporte.</p>

    <h2 className="text-lg font-semibold mt-4">6. Cookies</h2>
    <p>Usamos almacenamiento local del navegador para sesion e idioma. No usamos cookies de
    rastreo publicitario.</p>
  </Shell>
);
